'use client';

import type React from 'react';
import { Status } from '@yaradigitallabs/ahua-react';
import { ProductionLineStatusEnum } from '../utils/types';

const ProductionLineStatus: React.FC<{ status: ProductionLineStatusEnum }> = ({
  status,
}) => {
  return (
    <div className="flex justify-start items-center">
      <Status
        colorType={
          status === ProductionLineStatusEnum.REPORTED ? 'green' : 'gray'
        }
        iconLeading={
          status === ProductionLineStatusEnum.REPORTED ? 'Check' : 'Skeleton'
        }
        size="n"
      >
        {status === ProductionLineStatusEnum.REPORTED
          ? 'Reporting completed'
          : 'Reporting pending'}
      </Status>
    </div>
  );
};

export default ProductionLineStatus;
